export enum BrandMutationTypes {
    SET_BRAND = 'SET_BRAND',
}
